// extracted by mini-css-extract-plugin
export var blue = "c6_ct";
export var large = "c6_b2";
export var medium = "c6_b3";
export var white = "c6_jf";